<template>
   <section class="rr-wr">

   </section>
</template>
<script>
export default {
    name: "WhyRoori"
}
</script>
<style scoped lang="scss">

</style>
